import { render, staticRenderFns } from "./EntityDictEditor.vue?vue&type=template&id=5d1ab4de"
import script from "./EntityDictEditor.vue?vue&type=script&lang=js"
export * from "./EntityDictEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports